export default [
    {
        path: '/activity-offered-components',
        name: 'activity-offered-components',
        component: () => import ('./views/ActivityOfferedComponentIndex'),
        meta: { title: 'Componentes', icon: 'mdi-view-module-outline' },
    },
]
